<header class="app-header">
  <div class="header-content">
    <div class="header-left">
      @if (isStudentDashboard) {
        <img [src]="logo" alt="ElevateMe" class="header-logo" />
      } @else {
      <button class="sidebar-toggle-btn" (click)="toggleSidebar()" aria-label="Toggle sidebar">
        <img [src]="sidebarToggleIcon" alt="Toggle sidebar" />
      </button>
      }
    </div>

    <div class="header-center">
      @if (canUseGlobalSearch) {
        @if (!isSearchMobile) {
          <div class="search-container" #desktopSearchContainer [class.has-value]="hasSearchValue">
            <img [src]="searchIcon" alt="" class="search-icon" />
            <input
              type="text"
              id="header-search"
              name="headerSearch"
              pInputText
              [(ngModel)]="searchQuery"
              (ngModelChange)="onSearchQueryChange($event)"
              (focus)="onSearchFocus()"
              autocomplete="off"
              placeholder="Search student"
              class="search-input"
              aria-label="Search student"
            />
            @if (hasSearchValue) {
              <button
                type="button"
                class="search-clear-btn"
                (click)="onClearSearch($event)"
                aria-label="Clear search">
                <img [src]="cancelIcon" alt="" class="search-clear-icon" />
              </button>
            }
            @if (isSearchResultsOpen) {
              <div class="global-search-results" role="listbox" aria-label="Student search results">
                <ng-container *ngTemplateOutlet="globalSearchResultsBody"></ng-container>
              </div>
            }
          </div>
        }

        @if (isSearchMobile) {
          <button #searchIconBtn class="search-icon-btn" (click)="toggleSearchDropdown()" aria-label="Search">
            <img [src]="searchIcon" alt="Search" />
          </button>
        }
      }
    </div>

    @if (canUseGlobalSearch && isSearchMobile && isSearchDropdownOpen) {
      <div #searchDropdown class="search-dropdown">
        <div class="search-dropdown-content">
          <div class="search-container" [class.has-value]="hasSearchValue">
            <img [src]="searchIcon" alt="" class="search-icon" />
            <input
              type="text"
              id="header-search-mobile"
              name="headerSearchMobile"
              pInputText
              [(ngModel)]="searchQuery"
              (ngModelChange)="onSearchQueryChange($event)"
              autocomplete="off"
              placeholder="Search student"
              class="search-input"
              aria-label="Search student"
              autofocus
            />
            @if (hasSearchValue) {
              <button
                type="button"
                class="search-clear-btn"
                (click)="onClearSearch($event)"
                aria-label="Clear search">
                <img [src]="cancelIcon" alt="" class="search-clear-icon" />
              </button>
            }
            @if (isSearchResultsOpen) {
              <div class="global-search-results global-search-results--mobile" role="listbox" aria-label="Student search results">
                <ng-container *ngTemplateOutlet="globalSearchResultsBody"></ng-container>
              </div>
            }
          </div>
        </div>
      </div>
    }

    <div class="header-right">
      @if (canAddNotes) {
        <button
          type="button"
          class="header-add-notes-btn"
          aria-label="Add Notes"
          [pTooltip]="addNotesTooltip"
          tooltipPosition="top"
          tooltipStyleClass="header-add-notes-tooltip"
          [showDelay]="250"
          (click)="onAddNotesClick()">
          <img [src]="addNotesIcon" alt="" class="header-add-notes-icon" />
        </button>
      }
      @if (showHeaderInbox) {
        <div class="student-inbox-wrapper">
          <div class="header-notification" #notificationMenu>
            <button
              type="button"
              class="student-inbox-btn"
              [class.active]="isNotificationPreviewOpen || isNotificationsRoute"
              aria-label="Notifications"
              [attr.aria-expanded]="isNotificationPreviewOpen"
              (click)="toggleNotificationPreview($event)">
              <svg class="student-inbox-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M12.02 2.91C8.71 2.91 6.02 5.6 6.02 8.91V11.8C6.02 12.41 5.76 13.34 5.45 13.86L4.3 15.77C3.59 16.95 4.08 18.26 5.38 18.7C9.69 20.14 14.34 20.14 18.65 18.7C19.86 18.3 20.39 16.87 19.73 15.77L18.58 13.86C18.28 13.34 18.02 12.41 18.02 11.8V8.91C18.02 5.61 15.32 2.91 12.02 2.91Z" stroke="#A5A5A5" stroke-width="2.1" stroke-miterlimit="10" stroke-linecap="round"/>
                <path d="M13.87 3.2C13.56 3.11 13.24 3.04 12.91 3C11.95 2.88 11.03 2.95 10.17 3.2C10.46 2.46 11.18 1.94 12.02 1.94C12.86 1.94 13.58 2.46 13.87 3.2Z" stroke="#A5A5A5" stroke-width="2.1" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M15.02 19.06C15.02 20.71 13.67 22.06 12.02 22.06C11.2 22.06 10.44 21.72 9.9 21.18C9.36 20.64 9.02 19.88 9.02 19.06" stroke="#A5A5A5" stroke-width="2.1" stroke-miterlimit="10"/>
              </svg>
              @if (notificationUnreadCount > 0) {
                <span class="student-inbox-badge">{{ notificationUnreadCount }}</span>
              }
            </button>
            @if (isNotificationPreviewOpen) {
              <div class="notification-preview" role="dialog" aria-label="Notifications">
                <div class="notification-preview-header">
                  <h2>Notifications</h2>
                  @if (notificationUnreadCount > 0) {
                    <span>{{ notificationUnreadCount }} unread</span>
                  }
                </div>
                @if (notificationPreviewLoading) {
                  <p class="notification-preview-empty">Loading notifications...</p>
                } @else if (notificationPreview.length === 0) {
                  <p class="notification-preview-empty">You're all caught up.</p>
                } @else {
                  @for (item of notificationPreview; track item.inboxItemReceiverId) {
                    <button
                      type="button"
                      class="notification-preview-item"
                      [class.unread]="!item.isRead"
                      (click)="openNotification(item)">
                      <span class="notification-preview-avatar">
                        <img [src]="notificationAvatarIcon" alt="" />
                        @if (!item.isRead) {
                          <span class="notification-preview-dot" aria-hidden="true"></span>
                        }
                      </span>
                      <span class="notification-preview-copy">
                        <span class="notification-preview-top">
                          <span class="notification-preview-name">{{ previewName(item) }}</span>
                          @if (item.categoryName) {
                            <span class="notification-preview-section">{{ item.categoryName }}</span>
                          }
                        </span>
                        <span class="notification-preview-bottom">
                          <span class="notification-preview-message">{{ item.title }}</span>
                          <span class="notification-preview-meta">{{ item.timeAgo }}</span>
                        </span>
                      </span>
                    </button>
                  }
                }
                <button type="button" class="notification-preview-more" (click)="openAllNotifications()">
                  Show more
                </button>
              </div>
            }
          </div>
          @if (usesStudentInbox) {
            <a
              class="student-inbox-btn"
              [routerLink]="inboxRoute"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              aria-label="Inbox">
              <img [src]="inboxEmptyIcon" alt="" class="student-inbox-icon" />
              @if (inboxUnreadCount > 0) {
                <span class="student-inbox-badge">{{ inboxUnreadCount }}</span>
              }
            </a>
          }
        </div>
      }
      @if (currentUser$ | async; as user) {
        <div class="user-profile-wrapper">
          <div #userProfileBtn class="user-profile" [class.user-profile-static]="isStaffPortalPreview" (click)="!isMobileProfile && toggleUserProfileDropdown()">
            <p-avatar
              #userAvatar
              [image]="user.avatar"
              [label]="!user.avatar ? getInitials(user) : ''"
              shape="circle"
              styleClass="user-avatar"
              [style]="{ 'background-color': user.avatar ? 'transparent' : '#1A363A', color: '#ffffff' }"
              (click)="isMobileProfile && toggleUserProfileDropdown(); $event.stopPropagation()"
            ></p-avatar>
            <div class="user-info">
              <span class="user-name">{{ user.fullName }}</span>
              <span class="user-role">{{ getDisplayRole(user) }}</span>
            </div>
            @if (!isStaffPortalPreview) {
              <img
                [src]="chevronDownIcon"
                alt="Dropdown"
                class="user-dropdown"
                [class.rotated]="isUserProfileDropdownOpen"
                (click)="toggleUserProfileDropdown(); $event.stopPropagation()"
              />
            }
          </div>
          
          <!-- User Profile Dropdown -->
          @if (isUserProfileDropdownOpen && !isStaffPortalPreview) {
            <div #userProfileDropdown class="user-profile-dropdown">
              <!-- Mobile User Info (shown only on mobile) -->
              <div class="user-info-mobile">
                <p-avatar
                  [image]="user.avatar"
                  [label]="!user.avatar ? getInitials(user) : ''"
                  shape="circle"
                  styleClass="user-avatar-mobile"
                  [style]="{ 'background-color': user.avatar ? 'transparent' : '#1A363A', color: '#ffffff' }">
                </p-avatar>
                <div class="user-info-text-mobile">
                  <span class="user-name-mobile">{{ user.fullName }}</span>
                  <span class="user-role-mobile">{{ getDisplayRole(user) }}</span>
                </div>
              </div>
              <div class="menu-divider"></div>
              <div class="user-profile-menu">
                @if (isStudentDashboard) {
                  <button
                    class="menu-item"
                    type="button"
                    [disabled]="isStaffPortalPreview"
                    [attr.title]="isStaffPortalPreview ? 'Only students can access this.' : null"
                    (click)="onMenuItemClick('complaint')">
                    <span class="menu-item-text">Submit Complaint</span>
                  </button>
                }
                @if (!isStudentRole(user) && !isStaffPortalPreview) {
                  <button class="menu-item" (click)="onMenuItemClick('profile')">
                    <span class="menu-item-text">My profile</span>
                  </button>
                }
                @if (!isStaffPortalPreview) {
                  <button class="menu-item menu-item-danger" (click)="onMenuItemClick('logout')">
                    <span class="menu-item-text">Logout</span>
                  </button>
                }
               
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
</header>

<ng-template #globalSearchResultsBody>
  @if (isSearchLoading) {
    <div class="global-search-empty">Searching...</div>
  } @else if (searchResults.length === 0) {
    <div class="global-search-empty">No students found</div>
  } @else {
    @for (student of searchResults; track student.studentId) {
      <button
        type="button"
        class="global-search-item"
        role="option"
        (click)="onSelectStudent(student)">
        <span class="global-search-item-main">
          <span class="global-search-item-name">{{ student.studentName }}</span>
          <span class="global-search-item-meta">
            @if (student.email) {
              <span class="meta-email">{{ student.email }}</span>
            }
            @if (student.email && student.mobileNo) {
              <span class="meta-sep" aria-hidden="true">·</span>
            }
            @if (student.mobileNo) {
              <span class="meta-phone">{{ student.mobileNo | phoneMask }}</span>
            }
            @if (!student.email && !student.mobileNo) {
              <span>—</span>
            }
          </span>
        </span>
        @if (student.lifeCycleStatusName) {
          <span
            class="global-search-item-status"
            [style.background-color]="getStatusBgColor(student.lifeCycleStatusName)"
            [style.color]="getStatusColor(student.lifeCycleStatusName)">
            {{ student.lifeCycleStatusName }}
          </span>
        }
      </button>
    }
  }
</ng-template>

<app-notes-modal
  [(visible)]="isNotesModalOpen"
  [showStudentSelect]="true">
</app-notes-modal>

@if (isStudentDashboard) {
  <app-student-complaint [(visible)]="isComplaintModalOpen"></app-student-complaint>
}
